import { optionSearchTerms_safeMailingLists } from './SafeMailingListsOptionV2.locstring.json';
import { optionTitle_safeMailingLists } from 'owa-locstrings/lib/strings/optiontitle_safemailinglists.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const SafeMailingListsOptionV2: LazyOption = createLazyOption(
    {
        key: 'safeMailingListsV2',
        titleStringKey: optionTitle_safeMailingLists,
        searchTermsStringKey: optionSearchTerms_safeMailingLists,
        isHidden: () => {
            return IsShadowMailboxUser() || !isConsumer();
        },
    },
    lazyFullModule,
    m => m.default
);
export default SafeMailingListsOptionV2;
